import useMyProductFormContext from '@src/hooks/product/form/useProductFormContext'
import FileSelector from '@src/components/inputs/FileSelector'
import SampleProofFormItem from '@src/components/product/form/ProductForm/SampleProofFormItem'
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import LoadingIcon from '@src/components/icon/LoadingIcon'

const SampleProofForm = () => {
	const { getSampleProofFormProps } = useMyProductFormContext()
	const {
		removeSampleProof,
		sampleProofsBase64,
		loadingSampleProofFile,
		sampleProofFileTag,
		selectSampleProofFile,
		errorMsg,
	} = getSampleProofFormProps()

	return (
		<div>
			<SelectorWrapper>
				<FileSelector
					ref={sampleProofFileTag}
					label="인증 예시 사진(올바른 인증사진 업로드)"
					labelStyle={css`
						white-space: nowrap;
					`}
					buttonTxt="이미지 추가"
					onChange={selectSampleProofFile}
					wrapperStyle={css`
						padding: 0;
						flex-direction: column;
					`}
					uploadBtnStyle={css`
						background: #ffcf19;
						border-radius: 4px;
						font-weight: 600;
						font-size: 1.4rem;
						line-height: 1.7rem;
						letter-spacing: 0.2px;
						color: #000000;
						width: auto;
						height: auto;
						padding: 1rem;
					`}
					errorMsg={errorMsg}
				/>
				{loadingSampleProofFile && (
					<LoadingIconWrapper>
						<LoadingIcon width={20} height={20} />
					</LoadingIconWrapper>
				)}
			</SelectorWrapper>

			{Array.isArray(sampleProofsBase64) &&
				sampleProofsBase64.map((sampleProof, index) => {
					return (
						<div key={`proof-list-id-${sampleProof}`}>
							<SampleProofFormItem
								sampleProof={sampleProof}
								onCancelImg={() => {
									removeSampleProof(index)
								}}
							/>
						</div>
					)
				})}
		</div>
	)
}
const SelectorWrapper = styled.div`
	display: inline-block;
	position: relative;
`
const LoadingIconWrapper = styled.div`
	position: absolute;
	top: 34px;
	left: 0;
	right: 0;
	bottom: 0;
	margin: auto;
	background: #00000066;

	display: flex;
	align-items: center;
	justify-content: center;
`

export default SampleProofForm
